module.exports = __webpack_public_path__ + "static/img/g_4.8275b7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutcifi/g_4.jpg
// module id = PBle
// module chunks = 202